import { useNavigate } from "react-router";

import { t } from "i18next";

import { Box, Button } from "@mui/material";

import { theme } from "@/src/theme/theme";

import FAQSingleAccordion from "@/src/components/molecules/FAQSingleAccordion/FAQSingleAccordion";

import AB_TEST_IDS from "@/src/constants/abTestIds";
import { getFaqsInOrder } from "@/src/types/faq/faq.utils";

export type { FAQLink, FAQItem, FAQJsonType } from "@/src/types/faq/faq.types";
export { FAQJson, FAQJsonOld } from "@/src/types/faq/faq.data";
export { getFaqsInOrder } from "@/src/types/faq/faq.utils";

const FAQList = () => {
  const homePageFaqIds = [1, 7, 3, 4, 2, 8, 48];
  const homePageFaq = getFaqsInOrder(homePageFaqIds);

  const navigate = useNavigate();

  const handleNavigation = (url: string) => {
    navigate(url);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: ["column"],
        alignItems: "center",
        marginTop: 3,
        ul: {
          paddingLeft: 0,
          marginBlockStart: 0,
          marginBlockEnd: 0,
          listStyleType: "none",
          "&:first-of-type": {
            marginRight: [0, 0, theme.spacing(2)]
          },
          ".MuiAccordionSummary-root": {
            borderTop: "white 1px solid"
          }
        }
      }}
    >
      <ul>
        {homePageFaq.map((singleFaq, idx) => (
          <li key={singleFaq.id}>
            <FAQSingleAccordion item={singleFaq} index={idx + 1} />
          </li>
        ))}
      </ul>
      <Button
        onClick={() => handleNavigation("/faq")}
        variant="contained"
        sx={{
          width: ["100%", "150px", "150px"],
          mt: 2
        }}
        data-ab-test={AB_TEST_IDS.consumer.homepage.faq.readMore}
      >
        {t("faq.readMore")}
      </Button>
    </Box>
  );
};

export default FAQList;
